<template>
    <div style="width:100%;height:100%;position:relative;">
      <div class="flex-wrap" style="padding-right:32px;padding-left:5px;line-height:30px;cursor:pointer" :style="{color:items?'#39f':'#aaa'}" @click="modalSelector=true">
        {{'编辑'}}
      </div>
  
      <Modal v-model="modalSelector" :width="700" title="列编辑器" footer-hide>
        <div style="margin:0px;border:1px solid var(--border);border-radius:5px;">
        <div class="flex-wrap" style="align-content:flex-start;align-items:flex-start;">
           
          <div style="width:150px;border-right:1px solid var(--border);min-height:300px;">
            <div class="flex-wrap col-item" @click="add">
              <Icon type="md-add" size="16" style="margin-right:5px;" /> 新增
            </div>
            <template v-for="(c,i) in items || []">
              <div class="col-item" :class="{'col-item-selected':selected==c}" :key="c.key" @click="selected = c">
                {{c.name}}
              </div>
            </template>
           
          </div>
          <div style="flex-grow:1;">
            <div class="flex-wrap" style="border-bottom:1px solid var(--border)">
          
            <div class="flex-wrap flex-center" style="width:30px;height:29px;border-right:1px solid var(--border);cursor:pointer;" @click="swapup()">
               <Icon type="md-arrow-up" size="15" />
            </div>
            <div class="flex-wrap flex-center" style="width:30px;height:29px;border-right:1px solid var(--border);cursor:pointer;" @click="swapdown()">
               <Icon type="md-arrow-down" size="15" />
            </div>
            <div class="flex-wrap flex-center" style="width:30px;height:29px;border-right:1px solid var(--border);cursor:pointer;" @click="remove()">
               <Icon type="md-remove" size="15" />
            </div>
            </div>
            <BaseProperty v-model="selected" :attrs="Attrs" @on-change="handleChangeProperty" />
            <BaseProperty v-model="selected.config" :attrs="ConfigAttrs || []" v-if="ConfigAttrs.length > 0" />
          </div>
        </div>
        </div>
        <div class="flex-wrap flex-right" style="padding-top:10px;" >
          <Button @click="save" type="primary" size="large">保存</Button>
          <Button @click="cancel"  size="large" style="margin-left:10px;">取消</Button>
        </div>
      </Modal>
    </div>
  </template>
  
  <script>
  import {cloneDeep} from 'lodash';
  export default {
    data() {
      return {
        form: {},
        selected: {},
        modalSelector: false,
        globalID:0,
        items:[]
      };
    },
    props: ['value'],
    watch:{
      value:{
        handler(v){
          this.items = cloneDeep(v);
          if(this.items.length > 0){
            if(this.selected.key){
              this.selected = this.items.find((v)=>v.key == this.selected.key)
            }else{
              this.selected = this.items[0]
            }
          }else{
            this.selected = {}
          }
        },
        deep:true,
        immediate:true
      }
    },
    mounted() {
      this.selected = this.items[0];
    },
    methods: {
      emitChange(){
        this.$emit('input',this.items)
        this.$bus.$emit('calc-flex-table')
      },
      swapup() {
        const index = this.items.findIndex((v)=>v == this.selected);
        this.items.splice(index, 1);
        this.items.splice(index-1, 0, this.selected);
        this.emitChange();
      },
      swapdown() {
        const index = this.items.findIndex((v)=>v == this.selected);
        this.items.splice(index, 1);
        this.items.splice(index+1, 0, this.selected);
        this.emitChange();
      },
      createID(){
        let id = 'col'+this.globalID++;
        if(this.items.find((v)=>v.key == id)){
          return this.createID();
        }
        return id;
      },
      handleChangeProperty({key,value}){
        const needConfigControls = ['UgoInputSelect', 'UgoMultiSelect', 'UgoRadio'];
        if(key=='type'){
          if(needConfigControls.includes(value) && !this.selected.config){
            this.selected.config = {
              options:[],
              simple:true
            };
          }else{
            this.selected.config = {};
          }
        }
        this.emitChange();
      },
      add() {
        this.items.push({
          name: '新增',
          control: 'UgoInput',
          key: this.createID(),
          width:'auto',
          align:'center',
          config:{
            options:[],
            simple:true
          }
        });
        this.emitChange();
      },
      remove() {
        const index = this.items.findIndex((v)=>v == this.selected);
        this.items.splice(index, 1);
        this.emitChange();
      },
      save() {
        this.emitChange();
        this.modalSelector = false;
      },
      cancel(){
        this.$emit('on-cancel')
      }
    },
    computed: {
     
      Attrs() {
        const fields = [{
          label: '名称',
          key: 'name',
          control: 'Text',
          editable: true,
        }, {
          label: '数据名',
          key: 'key',
          control: 'Text',
          editable: true,
        }, {
          label: '类型',
          key: 'control',
          editable: true,
          control: 'Select',
          option: {
            options: [{
              label: '单行文本',
              value: 'UgoInput',
            }, {
              label: '数值',
              value: 'UgoNumber',
            }, {
              label: '多行文本',
              value: 'UgoTextarea',
            }, {
              label: '日期',
              value: 'UgoDate',
            }, {
              label: '单选',
              value: 'UgoRadio',
            }, {
              label: '输入选择框',
              value: 'UgoInputSelect',
            }, {
              label: '文件',
              value: 'UgoFileUpload',
            }, {
              label: '图片',
              value: 'UgoImage',
            }],
            defaultTo: 'UgoInput',
          },
        }, {
          label: '宽度',
          key: 'width',
          editable: true,
          option:{
            placeholder: '请输入宽度(固定宽度或百分比，如100或100%)',
          },
          control: 'Number',
          defaultTo:undefined
        }, {
          label: '对齐',
          key: 'width',
          editable: true,
          control: 'Select',
          option: {
            options: [{
              label: '左对齐',
              value: 'left',
            }, {
              label: '居中',
              value: 'center',
            }, {
              label: '右对齐',
              value: 'right',
            }],
          },
        }, {
          label: '必填',
          key: 'required',
          editable: true,
          control: 'Check',
        }];
        
        return [...fields];
      },
      ConfigAttrs() {
        let extra = [];
        const optionControls = ['UgoInputSelect', 'UgoMultiSelect', 'UgoRadio'];
        if (this.selected && optionControls.includes(this.selected.control)) {
          extra = [{
            key: 'options',
            control: 'SelectOption',
            editable: true,
            simple:true,
            label: '选项',
          }];
        }
        return extra;
      },
    },
  };
  </script>
  
  <style lang="less">
  .col-item{
    height:30px;
    padding:5px;
    cursor: pointer;
    border-bottom:1px solid var(--border);
    display: flex;
    align-items: center;
  
  
  }
  
  .col-item-selected{
    background:var(--primary);
    color:var(--hover-text);
  }
  </style>
  